import { z } from 'zod';

export const checkDirectionAngleSchema = z.number().int().min(0).max(359);
